import { default as module } from './AbstractModule';
import { APP_NAME, html, isMobile } from '../utils/environment';
import { lerp } from '../utils/maths';
import VirtualScroll from 'virtual-scroll';

const SPEED = 0.75
const animatedLineBlocks = ['left', 'middle', 'right']

export default class extends module {
    constructor(m) {
        super(m);

        window.app.hasIntro = true
        window.app.preventScroll = true

        this.skip = false
        let ls = window.localStorage.getItem(`${APP_NAME}.intro`)
        if(ls && ls.length) {
            ls = JSON.parse(ls)
            this.skip = ls.skip
        }

        if(this.skip)
            this.el.classList.add('has-no-tutorial')
        else
            this.el.classList.remove('has-no-tutorial')

        this.events = {
            click: 'continue'
        }

        // SELECT OUR ELEMENTS
        // First, get all our line elements
        this.animatedLine = { }
        for(const block of animatedLineBlocks) {
            this.animatedLine[block] = { el: this.$(block), target: this.$(block+'Target') }
        }
        this.initLines = this.$('initLine')
        this.lines = this.$('line')
        this.textBasis = this.$('textBasis')
        // Then, get each section specific elements
        // overlay
        this.overlay = this.$('overlay')
        this.overlayBgCols = this.$('overlay-bg-col')
        this.overlayText = this.$('overlay-text')
        this.overlayProgress = this.$('overlay-progress')
        // tutorial
        this.tutorial = this.$('tutorial')
        this.swipeIcon = this.$('swipeIcon')
        // video
        this.videoWrapper = this.$('video-wrapper')
        this.videoText = this.$('video-text')
        this.videoSrc = this.getData('src', this.videoWrapper)

        this.video = document.createElement('video')
        this.video.preload = 'all'
        this.video.autoplay = true
        this.video.muted = true
        this.video.playsinline = true
        this.video.loop = true
        this.video.setAttribute('preload', 'all')
        this.video.setAttribute('autoplay', '')
        this.video.setAttribute('muted', '')
        this.video.setAttribute('playsinline', '')
        this.video.setAttribute('loop', '')
        this.video.innerHTML = `<source src="${this.videoSrc}" type="video/mp4">`

        this.videoWrapper.prepend(this.video)
        // content
        this.contentCols = this.$('contentCol')
        this.contentButton = this.$('contentButton')
        this.contentColsInner = this.$('contentColInner')
        this.contentColsSplit = new SplitText(this.contentColsInner, { type: 'lines' })
        // circle related
        this.circle = this.$('circle')
        this.circleWrapper = this.$('circleWrapper')
        this.circleInner = this.$('circleInner')
        this.circleOuter = this.$('circleOuter')

        // START THIS THING
        this
        .start()
        .then(() => {
            this.compute()
            this.ready = true;

            this.videoLoadBind = this.compute.bind(this)
            this.video.addEventListener('loadedmetadata', this.videoLoadBind)

            this.manageSwipe()

            if(this.skip) {
                this.timeout = setTimeout(() => {
                    this.continue()
                }, 500);
            } else {
                let duration = 5
                this.progressTw = TweenMax.fromTo(this.overlayProgress, duration, { opacity: 1, scaleX: 0 }, { scaleX: 1, ease: Linear.easeNone })
                this.timeout = setTimeout(() => {
                    this.continue()
                }, duration*1000);
            }
        })

        this.highlightMouseEnter = (e) => {
            let id = this.getData('id', e.target)
            this.call('show', e, 'Intromask', id)
        }
        this.highlightMouseLeave = (e) => {
            let id = this.getData('id', e.target)
            this.call('hide', e, 'Intromask', id)
        }

        this.onWheelBind = (e) => {
            if(e.deltaY > 0) this.continue()
        }
        document.addEventListener('wheel', this.onWheelBind)

        this.overlay.style.height = window.innerHeight+'px'

        this.onResizeBind = () => {
            this.overlay.style.height = window.innerHeight+'px'
            this.compute()
        }
        window.addEventListener('resize', this.onResizeBind)
    }

    start() {
        return new Promise(resolve => {
            this.initTl = new TimelineMax({ onComplete: () => {
                resolve()
            } })

            for(let i = this.initLines.length - 1; i >= 0; i--) {
                this.initTl.fromTo(this.initLines[i], SPEED, { y: (100 * (i+1))+'%', opacity: 0, force3D: true, ease: Power2.easeOut }, { y: '0%', opacity: 1 }, i * SPEED/10)
            }
        })
    }

    compute() {
        this.viewport = {
            width: window.innerWidth,
            height: window.innerHeight
        }

        const videoWrapperBCR = this.videoWrapper.getBoundingClientRect()
        const videoWrapperRatio = videoWrapperBCR.width / videoWrapperBCR.height
        const videoRatio = this.video.videoWidth / this.video.videoHeight
        let top,left,height,width;
        if(videoWrapperRatio < videoRatio) {
            top = '0px';
            height = '100%';
            width = 'auto';
            const realW = videoWrapperBCR.height * videoRatio;
            left = (-(realW - videoWrapperBCR.width)/2)+'px'
        } else {
            left = '0px';
            height = 'auto';
            width = '100%';
            const realH = videoWrapperBCR.width * (1/videoRatio)
            top = (-(realH - videoWrapperBCR.height)/2)+'px'
        }
        TweenMax.set(this.video, { top, left, width, height })

        this.scrollSize = this.viewport.width/2

        for(const block of animatedLineBlocks) {
            this.animatedLine[block].elBCR = this.animatedLine[block].el[0].getBoundingClientRect();
            this.animatedLine[block].targetBCR = this.animatedLine[block].target[0].getBoundingClientRect();
            this.animatedLine[block].offset = {
                x: (this.animatedLine[block].targetBCR.left + this.animatedLine[block].targetBCR.width/2) - (this.animatedLine[block].elBCR.left + this.animatedLine[block].elBCR.width/2),
                y: (this.animatedLine[block].targetBCR.top + this.animatedLine[block].targetBCR.height/2) - (this.animatedLine[block].elBCR.top + this.animatedLine[block].elBCR.height/2)
            }
            this.animatedLine[block].scaleFactor = this.animatedLine[block].targetBCR.width / this.animatedLine[block].elBCR.width
        }
    }

    continue() {
        if(!this.ready || this.continued) return
        this.continued = true
        clearTimeout(this.timeout)

        window.localStorage.setItem(`${APP_NAME}.intro`, JSON.stringify({ skip: true }))

        if(this.panManager) {
            this.killSwipe()
        }

        if(this.progressTw && this.progressTw.kill) this.progressTw.kill()
        this.progressTw = TweenMax.to(this.overlayProgress, SPEED*0.5, { scaleX: 1, opacity: 0 });

        this.tl = new TimelineMax({
            onComplete: () => {
                if(this.destroying) return

                this.contentColsSplit.revert()

                this.underline = this.$('underline')
                this.highlights = this.$('highlight')

                for(let highlight of Array.from(this.highlights)) {
                    highlight.addEventListener('mouseenter', this.highlightMouseEnter)
                    highlight.addEventListener('mouseleave', this.highlightMouseLeave)
                }

                let i = 0
                for(const item of [this.underline, ...Array.from(this.highlights)]) {
                    setTimeout(() => {
                        item.classList.add('is-show')
                    }, 100 * i);
                    i++
                }

                i = 0;
                for(const item of Array.from(this.highlights)) {
                    setTimeout(() => {
                        item.classList.add('-highlight')
                    }, 2000 * i);
                    i++
                }

                // debugger;
                html.classList.remove('has-intro-active')
                this.el.classList.add('-show-final-text')
                for(let textBasis of Array.from(this.textBasis)) {
                    textBasis.parentNode.removeChild(textBasis)
                }
                this.final()
            }
        })

        this.tl.addLabel('start', 0)

        // Hide the sentence
        this.tl.to(this.lines[0], SPEED*0.5, { y: '-200%', opacity: 0, force3D: true, ease: Power2.easeIn }, 'start')
        this.tl.to(this.lines[1], SPEED*0.5, { y: '-100%', opacity: 0, force3D: true, ease: Power2.easeIn }, 'start')
        if(isMobile) this.tl.to(this.initLines[2], SPEED*0.5, { y: '-50%', opacity: 0, force3D: true, ease: Power2.easeIn }, 'start')

        // Hide tutorial
        this.tl.to(this.tutorial, SPEED, { opacity: 0 }, 'start')

        // On Desktop, move `Born`, `&` and `Bred` on X axis to match with their destination
        if(!isMobile) {
            for(const block of animatedLineBlocks) {
                this.tl.to(this.animatedLine[block].el, SPEED, { x: this.animatedLine[block].offset.x, force3D: true, ease: Power2.easeInOut }, 'start')
            }

            this.tl.addLabel('step1', SPEED*0.5)
        } else {
            this.tl.addLabel('step1', SPEED*0.25)
        }

        // On Desktop, scale up the words `Born`, `&` and `Bred` to match with their destination
        let i
        if(!isMobile) {
            i = 0
            for(const block of animatedLineBlocks) {
                this.tl.to(this.animatedLine[block].el, SPEED, { scale: this.animatedLine[block].scaleFactor, force3D: true, ease: Power2.easeInOut }, 'step1+='+(i*(SPEED/10)))
                i++
            }

            this.tl.addLabel('step2', 'step1+='+SPEED*0.5)
        } else {
            this.tl.addLabel('step2', 'step1+='+SPEED*0.25)
        }

        // On Desktop, move `Born`, `&` and `Bred` on Y axis to match with their destination
        if(!isMobile) {
            i = 0
            for(const block of animatedLineBlocks) {
                this.tl.to(this.animatedLine[block].el, SPEED, { y: this.animatedLine[block].offset.y, force3D: true, ease: Power2.easeInOut }, 'step2+='+(i*(SPEED/10)))
                i++
            }
        }

        // Hide the columns
        i = 0
        for(let col of Array.from(this.overlayBgCols)) {
            this.tl.to(col, SPEED, { y: '-100%', force3D: true, ease: Power2.easeInOut }, 'step2+='+(i*(SPEED/15)))
            i++
        }

        // Show new content line by line
        this.tl.staggerFromTo(this.contentColsSplit.lines, SPEED*0.75, { y: '200%', opacity: 0 }, { y: '0%', opacity: 1, ease: Power2.easeOut }, SPEED*0.1, 'step2+='+(SPEED*0.3));

        // hide white text that was on the very top
        this.tl.to(this.overlayText, SPEED*0.5, { opacity: 0 }, 'step2+='+(SPEED/2))

        this.tl.addCallback(() => {
            html.classList.remove('has-intro-dark')

            if(isMobile) {
                html.classList.remove('has-intro-light-logo')
            }
        }, 'step2+='+(SPEED*0.8))

        this.tl.play()
    }

    final() {
        if(this.destroying) return

        if(isMobile) {
            this.enableScroll()

            return
        }

        if(!this.finalOnce) {
            this.scrollTl = {
                master: null,
                secondary: null,
            }
        } else {
            this.scrollTl.master.kill()
            this.scrollTl.secondary.kill()

            TweenMax.set([this.contentCols, this.contentButton, this.videoWrapper, this.videoText], { clearProps: 'all' })
            TweenMax.set(this.video, { clearProps: 'transform' })
        }

        this.scrollTl.secondary = new TimelineMax({});
        this.scrollTl.secondary.to([this.contentCols], 1, { x: '-200%', ease: Linear.easeNone }, 0)
        this.scrollTl.secondary.to([this.contentButton], 1, { x: '-100%', ease: Linear.easeNone }, 0)
        this.scrollTl.secondary.pause()

        let scaleObject = {
            value: 0.2
        }
        this.scrollTl.master = new TimelineMax({
            onUpdate: () => {
                TweenMax.set(this.circle, { scale: scaleObject.value })
                TweenMax.set(this.circleOuter, { scale: 1/scaleObject.value })
            }
        });
        this.scrollTl.master.to(this.videoWrapper, 1, { x: -this.viewport.width/2, ease: Linear.easeNone }, 0)
        this.scrollTl.master.to(this.videoText, 1, { x: this.viewport.width/2, ease: Linear.easeNone }, 0)
        this.scrollTl.master.to(this.video, 1, { x: this.viewport.width/4, scale: 1.5, ease: Linear.easeNone }, 0)

        const CIRCLE_SCALE = 0.2

        this.scrollTl.master.set(this.circle, { opacity: 1,  }, 0)

        this.scrollTl.master.set(this.circleWrapper, { y: this.viewport.height*0.1 }, 0)
        this.scrollTl.master.set(this.circleInner, { y: -this.viewport.height*0.1 }, 0)

        this.scrollTl.master.fromTo(scaleObject, 1, { value: 0.2 }, { value: 1.0, ease: Linear.easeNone }, 0)
        this.scrollTl.master.fromTo(this.circleWrapper, 1, { x: this.viewport.width*1.5 }, { x: this.viewport.width*0.66, force3D: true, ease: Linear.easeNone }, 0)
        this.scrollTl.master.fromTo(this.circleInner, 1, { x: -this.viewport.width*1.5 }, { x: -this.viewport.width*0.66, ease: Linear.easeNone }, 0)

        this.scrollTl.master.pause()

        if(!this.scrollDelta) {
            this.scrollDelta = {
                x: 0,
                y: 0
            }
        } else if(!this.scrollActive) {
            this.scrollDelta.y = this.scrollSize
        }

        if(!this.scrollValue) {
            this.scrollValue = {
                x: 0,
                y: 0
            }
        } else if(!this.scrollActive) {
            this.scrollValue.y = this.scrollSize
        }


        if(!this.finalOnce) {
            this.scroll = new VirtualScroll({
                mouseMultiplier: (navigator.platform.indexOf('Win') > -1) ? 1 : 0.4,
                touchMultiplier: 4,
                firefoxMultiplier: 30
            });

            this.scrollBind = (e) => {
                requestAnimationFrame(() => {
                    if(this.scrollActive) {
                        this.scrollDelta.y -= e.deltaY;

                        if(this.scrollDelta.y < 0) this.scrollDelta.y = 0
                        else if(this.scrollDelta.y >= this.scrollSize) {
                            this.scrollDelta.y = this.scrollSize
                            this.disableScroll(100)
                        }
                    }
                });
            }
            this.scroll.on(this.scrollBind);

            this.update()
            this.enableScroll()
        }

        this.finalOnce = true
        this.finalResizeBind = () => {
            window.removeEventListener('resize', this.finalResizeBind)
            this.final()
        }
        window.addEventListener('resize', this.finalResizeBind)
    }

    enableScroll(delay = 0) {
        clearTimeout(this.disableScrollTimeout)
        window.app.preventScroll = true
        window.app.introScrollRequested = true

        this.enableScrollTimeout = setTimeout(() => {
            this.scrollActive = true
        }, delay)
    }

    disableScroll(delay = 0) {
        clearTimeout(this.enableScrollTimeout)
        this.scrollActive = false

        this.disableScrollTimeout = setTimeout(() => {
            window.app.preventScroll = false

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    window.app.introScrollRequested = false
                })
            })
        }, delay);
    }

    manageSwipe() {

        // Tween piloting swipe icon
        this.swipeTl = new TimelineMax({
            onComplete: () => {
                this.continue()
            }
        });

        this.swipeTl.to(this.swipeIcon, 1, { opacity: 0, y: '-300%', ease: Linear.easeNone })
        this.swipeTl.pause()
        this.swipeTl.progress(0)

        // Inits hammer manager
        this.panManager = new Hammer.Manager(this.el);
        this.panManager.add(new Hammer.Pan({ direction: Hammer.DIRECTION_VERTICAL, threshold: 0 }));

        // Local variables used inside panManager event listeners
        let resetTw
        let progressOnGrabStart

        // PAN START
        this.onPanStart = (e) => {
            // Store starting position
            progressOnGrabStart = this.swipeTl.progress()
        }
        this.panManager.on('panstart', this.onPanStart);

        // PAN MOVE
        this.onPanMove = (e) => {
            // Update swipeTl tween to reflect on view
            let delta = e.deltaY / 200;
            let newProgress = progressOnGrabStart - delta;
            newProgress = Math.min(1, Math.max(0, newProgress))
            this.swipeTl.progress(newProgress)
        }
        this.panManager.on('panstart panmove', this.onPanMove);

        // PAN END
        this.onPanEnd = (e) => {
            // Interaction ended, decide wether it's considered as a swipe or not
            if(this.swipeTl.progress() > 0.4 || e.velocityY < -.5) { // If so, kill any reset tween and quickly tween to the end of the animation which will triggering the `continue()` method
                if(resetTw && resetTw.kill) resetTw.kill()
                let object = { value: this.swipeTl.progress() }
                TweenMax.to(object, .25, { value: 1, ease: Power2.easeOut, onUpdate: () => {
                    this.swipeTl.progress(object.value)
                } })

                // Also we stop to listen for any pan event
                this.killSwipe()
            } else { // Not enough of a swipe, create a tween to reset to progress 0
                if(resetTw && resetTw.kill) resetTw.kill()
                let object = { value: this.swipeTl.progress() }
                resetTw = TweenMax.to(object, .5, { value: 0, ease: Power2.easeOut, onUpdate: () => {
                    this.swipeTl.progress(object.value)
                } })
            }
        }
        this.panManager.on('panend', this.onPanEnd);
    }

    killSwipe() {
        this.panManager.off('panstart', this.onPanStart);
        this.panManager.off('panstart panmove', this.onPanMove);
        this.panManager.off('panend', this.onPanEnd);
        this.panManager.destroy()
        this.panManager = null
    }

    update() {
        let direction
        if (this.scrollDelta.y >= this.scrollValue.y) {
            direction = 'down'
        } else if (this.scrollDelta.y < this.scrollValue.y) {
            direction = 'up'
        }

        this.scrollValue.y = lerp(this.scrollValue.y, this.scrollDelta.y, 0.1)

        let masterProgress = this.scrollValue.y/this.scrollSize
        if(!window.isloading) {
            if(masterProgress < 0.8)
                html.classList.add('has-intro-light-logo')
            else
                html.classList.remove('has-intro-light-logo')
        }

        this.scrollTl.master.progress(masterProgress)

        let secondaryProgress = this.scrollTl.secondary.progress()
        secondaryProgress = lerp(secondaryProgress, masterProgress, direction == 'down' ? 0.2 : 0.1)
        this.scrollTl.secondary.progress(secondaryProgress)

        this.raf = requestAnimationFrame(this.update.bind(this))
    }

    destroy() {
        this.destroying = true

        this.disableScroll()

        if(this.tl && this.tl.kill) this.tl.kill()
        if(this.scrollTl && this.scrollTl.master && this.scrollTl.master.kill) this.scrollTl.master.kill()
        if(this.scrollTl && this.scrollTl.secondary && this.scrollTl.secondary.kill) this.scrollTl.secondary.kill()

        if(this.highlights) {
            for(let highlight of Array.from(this.highlights)) {
                highlight.removeEventListener('mouseenter', this.highlightMouseEnter)
                highlight.removeEventListener('mouseleave', this.highlightMouseLeave)
            }
        }

        if(this.panManager) {
            this.killSwipe()
        }

        if(this.scroll) {
            window.app.preventScroll = false
            this.scroll.off(this.scrollBind);
            this.scroll.destroy()
            this.scroll = null
        }

        this.video.removeEventListener('load', this.videoLoadBind)

        window.cancelAnimationFrame(this.raf)
        window.removeEventListener('resize', this.onResizeBind)
        window.removeEventListener('resize', this.finalResizeBind)
        document.removeEventListener('wheel', this.onWheelBind)

        window.app.hasIntro = false
    }
}
